import React, {Component, PropTypes} from 'react';
import IconButton from 'material-ui/IconButton/IconButton';
import Remove from 'material-ui/svg-icons/content/remove';

const RemoveButton = (props) => <IconButton {...props}><Remove {...props.iconProps}/></IconButton>;

RemoveButton.propTypes = {
    iconProps: PropTypes.object,
};

export default RemoveButton;


/** WEBPACK FOOTER **
 ** ./app-react/components/Buttons/Remove.jsx
 **/